import { useSelector } from 'react-redux';

const useFeatureFlag = (flagName) => {
	const { featureFlags, isLoading } = useSelector(state => state.configuration);

	if (isLoading) return false;

	return !!featureFlags[flagName];
};

export default useFeatureFlag;
